"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/FileMessage/FileVideo/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _DerivativeImage = require('../DerivativeImage'); var _DerivativeImage2 = _interopRequireDefault(_DerivativeImage);
var _VideoOverlay = require('../VideoOverlay'); var _VideoOverlay2 = _interopRequireDefault(_VideoOverlay);
var _ModalView = require('./ModalView'); var _ModalView2 = _interopRequireDefault(_ModalView);















const FileVideo = ({
  fileName,
  thumbnailUrl,
  blurHash,
  imageWidth,
  imageHeight,
  durationMs,
  onRequestFreshThumbnail,
  onRequestOriginal,
  onDownloadOriginal,
  children,
}) => {
  const [showingLightbox, setShowingLightbox] = _react.useState.call(void 0, false)
  const [originalUrl, setOriginalUrl] = _react.useState(null)
  const closeLightBox = () => setShowingLightbox(false)
  const openLightBox = () => {
    setShowingLightbox(true)
    if (!originalUrl) onRequestOriginal().then(setOriginalUrl)
  }

  const modalGateway = window.location === window.parent.location
    ? _react2.default.createElement(_Modal2.default, {
        isOpen: showingLightbox,
        fullScreen: true,
        onClose: closeLightBox,
        className: "file-image--preview-modal",
        bodyClassName: "file-image--preview-modal--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}

        , originalUrl && _react2.default.createElement(_ModalView2.default, {
          videoSrc: originalUrl,
          videoCaption: fileName,
          onClose: closeLightBox,
          onDownload: _nullishCoalesce(onDownloadOriginal, () => ( (() => window.open(originalUrl)))), __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}
        )
      )
    : null

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , modalGateway
      , _react2.default.createElement(_DerivativeImage2.default, {
        blurHash: blurHash,
        thumbnailUrl: thumbnailUrl,
        width: imageWidth,
        height: imageHeight,
        fileName: fileName,
        onRequestFreshThumbnail: onRequestFreshThumbnail,
        onOpenOriginal: openLightBox, __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}

        , _react2.default.createElement(_VideoOverlay2.default, { durationMs: durationMs, __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}} )
        , children
      )
    )
  )
}

exports. default = FileVideo
